const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.valeglobal.forwoodsafety.com',
    USER_TOKEN_URL: 'https://6iff88umn1.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://1h5hec9ldd.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'teams-container-1.11.7',
    HOSTNAME: 'https://teams.staging.valeglobal.forwoodsafety.com',
    TEAMS_MICROFRONTEND_URL: 'https://teams-service.staging.valeglobal.forwoodsafety.com',
    TARGETS_MICROFRONTEND_URL: 'https://targets.staging.valeglobal.forwoodsafety.com',
    TEAMS_ACCESS_ROLE: 'TeamsAccess',
    TEAM_TARGETS_ACCESS_ROLE: 'TeamTargetsAccess',
  },
  configurationService: {
    URL: 'https://config.staging.valeglobal.forwoodsafety.com',
    WEBSOCKET: 'wss://fjbp8skumh.execute-api.us-west-2.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
